export const getNewWebsite = ({ prevState, websiteToAdd }) => {
  const { id, url, hasOperatorsByDefault } = websiteToAdd;
  const operators = hasOperatorsByDefault
    ? getReformattedOperators(prevState.operators)
    : [];

  return {
    id,
    url,
    logoUrl: '',
    widgetInstalled: false,
    isActive: true,
    operators: operators,
  };
};

export const getCurrentWebsite = ({ prevState, websiteId }) => {
  const currentWebsite = prevState.websites.data.find(
    (website) => website.id === websiteId
  );
  return {
    ...currentWebsite,
  };
};

export const handleOperatorsAssignment = ({
  prevState,
  selectedOperatorsIds,
}) => {
  const { websites, operators } = prevState;
  const selectedOperators = getSelectedOperatorsFromIds(
    operators,
    selectedOperatorsIds
  );
  const updatedWebsites = websites.map((website) => {
    return website.id === prevState.currentWebsite.id
      ? {
          ...website,
          operators: selectedOperators,
        }
      : website;
  });
  return updatedWebsites;
};

export const getReformattedOperators = (operators = []) => {
  const reformattedOperators = operators.map((operator) => ({
    id: operator.id,
    fullName: operator.fullName,
    imageUrl: operator.imageUrl,
  }));

  return reformattedOperators;
};

export const getSelectedOperatorsFromIds = (
  operators,
  selectedOperatorsIds = []
) => {
  const filteredOperators = operators.data.filter((operator) =>
    selectedOperatorsIds.includes(operator.id)
  );
  return getReformattedOperators(filteredOperators);
};
